export default __webpack_public_path__ + "static/media/title_mob.29f5bf3a.svg";